import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ChequeNumberPopup = ({ show, onHide, onConfirm, chequeNumber, setChequeNumber }) => {
    const handleConfirm = () => {
        if (chequeNumber.trim()) {
            onConfirm();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Enter Cheque Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Cheque Number"
                    value={chequeNumber}
                    onChange={(e) => setChequeNumber(e.target.value)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleConfirm} disabled={!chequeNumber.trim()}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChequeNumberPopup;
